import styled from "styled-components"
import { Link } from "react-router-dom"

export const Wrapper = styled.header``

export const Component = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 8px;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.bp.xsmall}px) {
    position: relative;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.white.main};
    border-radius: 8px;
  }
`

export const LogoArea = styled.div`
  width: fit-content;

  a {
    width: fit-content;
    display: flex;
    align-items: center;
    height: 86px;
    overflow: hidden;
    text-decoration: none;

    img {
      max-height: 100%;
      width: auto;
      max-width: 120px;
    }

    span {
      color: #1a1f2e;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.4px;
      padding: 8px 4px;
      border-radius: 8px;
      transition: color 0.2s ease;

      &:hover {
        color: ${({ theme }) => theme.colors.blue.main};
        text-decoration: none;
      }
    }
  }
`

const navLinkBase = `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 10px 18px;
  border-radius: 999px;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }
`

/* Computador: links em linha (Suporte, Meus Ingressos, Sair). */
export const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;

  .nav-primary {
    ${navLinkBase}
    background-color: ${({ theme }) => theme.colors.blue.main};
    color: ${({ theme }) => theme.colors.white.main};

    &:hover {
      background-color: #0052c7;
    }
  }

  .nav-link {
    ${navLinkBase}
    background-color: transparent;
    color: ${({ theme }) => theme.colors.blue.main};

    &:hover {
      background-color: rgba(0, 97, 230, 0.08);
    }
  }

  .nav-logout {
    ${navLinkBase}
    padding: 10px 14px;
    background-color: transparent;
    color: #475569;

    &:hover {
      background-color: rgba(71, 85, 105, 0.08);
      color: #1a1f2e;
    }
  }

  .nav-divider {
    width: 1px;
    height: 20px;
    margin: 0 4px;
    background-color: #e2e8f0;
  }

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    display: none;
  }
`

/* Celular: botão redondo e cartão compacto que abre abaixo dele. */
export const MobileNav = styled.div`
  position: relative;
  display: none;

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    display: block;
  }

  /* Até 320px o cabeçalho vira coluna: o botão fica no canto. */
  @media (max-width: ${({ theme }) => theme.bp.xsmall}px) {
    position: absolute;
    top: 12px;
    right: 12px;
  }
`

export const MenuButton = styled.button`
  position: relative;
  z-index: 101;
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.white.main};
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.16);
  color: #1a1f2e;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.blue.main};
    outline-offset: 2px;
  }
`

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99;
  background: rgba(15, 23, 42, 0.28);
  animation: header-fade 0.15s ease-out;

  @keyframes header-fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const MenuPanel = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 100;
  width: min(260px, calc(100vw - 32px));
  padding: 8px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  gap: 2px;
  transform-origin: top right;
  animation: header-pop 0.16s ease-out;

  @keyframes header-pop {
    from {
      opacity: 0;
      transform: translateY(-6px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const MenuItem = styled(Link)<{ $active: boolean; $muted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 0 14px;
  border-radius: 12px;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  color: ${({ $active, $muted, theme }) =>
    $active ? theme.colors.blue.main : $muted ? "#64748b" : "#1a1f2e"};
  background-color: ${({ $active }) =>
    $active ? "rgba(0, 97, 230, 0.08)" : "transparent"};

  svg {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    color: ${({ $active, $muted, theme }) =>
      $active ? theme.colors.blue.main : $muted ? "#94a3b8" : "#475569"};
  }

  &:hover,
  &:focus-visible {
    background-color: ${({ $active }) =>
      $active ? "rgba(0, 97, 230, 0.12)" : "#f1f5f9"};
    outline: none;
  }
`

export const MenuDivider = styled.div`
  height: 1px;
  margin: 6px 8px;
  background: #e2e8f0;
`
